import cloneDeep from 'lodash/cloneDeep'

class ResidentialCanteensFormMapper {
    toEntity(values) {
        const entity = cloneDeep(values)

        return entity
    }

    fromEntity(entity) {
        const values = cloneDeep(entity)
        if (entity?.address) {
            values.address = entity.address['@id']
        }

        return values
    }
}

export default new ResidentialCanteensFormMapper()
